module.exports = __webpack_public_path__ + "img/top.0eefdeb0.png";